import { EventAction } from '../../types/events';
import eventQueue from '../queue';
function attachEventListeners() {
    eventQueue.on('bottom_sheet', function (_a) {
        var eventId = _a.eventId, isOpen = _a.isOpen, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (eventId === 'lookupFailed') {
            if (isOpen) {
                return fireAnalyticsEvent(EventAction.SHOW_POPUP_LOOKUP_FAILED);
            }
            return fireAnalyticsEvent(EventAction.HIDE_POPUP_LOOKUP_FAILED);
        }
        if (eventId === 'matchedPlatformFound') {
            if (isOpen) {
                return fireAnalyticsEvent(EventAction.SHOW_POPUP_PLATFORM_MATCH_FOUND);
            }
            return fireAnalyticsEvent(EventAction.HIDE_POPUP_GO_TO_SEARCH);
        }
        if (eventId === 'adpRerouteBottomSheet') {
            if (isOpen) {
                return fireAnalyticsEvent(EventAction.SHOW_POPUP_PLATFORM_LOGIN_BASED_FOUND);
            }
            return fireAnalyticsEvent(EventAction.HIDE_POPUP_GO_TO_SEARCH);
        }
        if (eventId === 'loginWithMatchedPlatform') {
            return fireAnalyticsEvent(EventAction.HIDE_POPUP_GO_TO_MATCH);
        }
        if (eventId === 'loginWithADPTestPlatform') {
            return fireAnalyticsEvent(EventAction.HIDE_POPUP_GO_TO_LOGIN_BASED);
        }
        return null;
    });
}
attachEventListeners();
